export default __webpack_public_path__ + "static/media/waiting-mcq.5ef09244.gif";